import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetPostRsvpDecisionDataQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  eventId: Types.Scalars['ID'];
}>;

export type GetPostRsvpDecisionDataQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks'; id: string; bookingLink?: string | null } | null;
    customPages?: Array<{
      __typename?: 'EventPageInfo';
      id: string;
      page: { __typename?: 'EventPage'; id: string; pageSlug: string; visibility: Types.EventPageVisibility };
    }> | null;
    travelPages?: Array<{ __typename?: 'EventPageInfo'; id: string; visibility: Types.EventPageVisibility }> | null;
    registryPages?: Array<{
      __typename?: 'EventPageInfo';
      id: string;
      page: { __typename?: 'EventPage'; id: string; pageSlug: string; visibility: Types.EventPageVisibility };
    }> | null;
  } | null;
  getRegistryEventData?: { __typename?: 'EventData'; id: string; hideRegistryInMessaging: boolean } | null;
};

export const GetPostRsvpDecisionDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPostRsvpDecisionData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hotelRoomBlocks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bookingLink' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'customPages' },
                  name: { kind: 'Name', value: 'pagesInfo' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'custom' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'travelPages' },
                  name: { kind: 'Name', value: 'pagesInfo' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'travel' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'registryPages' },
                  name: { kind: 'Name', value: 'pagesInfo' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'registry' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideRegistryInMessaging' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPostRsvpDecisionDataQuery__
 *
 * To run a query within a React component, call `useGetPostRsvpDecisionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostRsvpDecisionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostRsvpDecisionDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPostRsvpDecisionDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostRsvpDecisionDataQuery, GetPostRsvpDecisionDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetPostRsvpDecisionDataQuery, GetPostRsvpDecisionDataQueryVariables>(GetPostRsvpDecisionDataDocument, baseOptions);
}
export function useGetPostRsvpDecisionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostRsvpDecisionDataQuery, GetPostRsvpDecisionDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetPostRsvpDecisionDataQuery, GetPostRsvpDecisionDataQueryVariables>(GetPostRsvpDecisionDataDocument, baseOptions);
}
export type GetPostRsvpDecisionDataQueryHookResult = ReturnType<typeof useGetPostRsvpDecisionDataQuery>;
export type GetPostRsvpDecisionDataLazyQueryHookResult = ReturnType<typeof useGetPostRsvpDecisionDataLazyQuery>;
export type GetPostRsvpDecisionDataQueryResult = Apollo.QueryResult<GetPostRsvpDecisionDataQuery, GetPostRsvpDecisionDataQueryVariables>;
